import { render, staticRenderFns } from "./InComing.vue?vue&type=template&id=66850d87&scoped=true&"
import script from "./InComing.vue?vue&type=script&lang=js&"
export * from "./InComing.vue?vue&type=script&lang=js&"
import style0 from "./InComing.vue?vue&type=style&index=0&id=66850d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66850d87",
  null
  
)

component.options.__file = "InComing.vue"
export default component.exports